namespace TabAurous.OMS {
    export interface VendorRow {
        LedgerId?: number;
        PartyType?: string;
        PartyCode?: string;
        LedgerName?: string;
        AccountGroupId?: number;
        Nature?: string;
        TermId?: number;
        MailingName?: string;
        BillbyBill?: boolean;
        IsDisabled?: boolean;
        TaxRegType?: string;
        GstVat?: string;
        Pan?: string;
        CurrencyId?: number;
        LbrFlag?: boolean;
        StnFlag?: boolean;
        LbrFromDate?: string;
        LbrToDate?: string;
        LbrPricegroupId?: number;
        LbrAddDisc?: number;
        LbrAddMkp?: number;
        StnFromDate?: string;
        StnToDate?: string;
        CostPricegroupId?: number;
        StnAddDisc?: number;
        StnAddMkp?: number;
        AddressDetails?: AddressMasterRow[];
        ContactDetails?: ContactDetailsRow[];
        Token?: string;
        APIEndpoint?: string;
        APIToken?: string;
        AutoCreateVoucherUsingAPI?: boolean;
        AutoPosting?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace VendorRow {
        export const idProperty = 'LedgerId';
        export const nameProperty = 'LedgerName';
        export const localTextPrefix = 'OMS.Vendor';
        export const deletePermission = 'Vendor:Delete';
        export const insertPermission = 'Vendor:Add';
        export const readPermission = '*';
        export const updatePermission = 'Vendor:Edit';

        export declare const enum Fields {
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            PartyCode = "PartyCode",
            LedgerName = "LedgerName",
            AccountGroupId = "AccountGroupId",
            Nature = "Nature",
            TermId = "TermId",
            MailingName = "MailingName",
            BillbyBill = "BillbyBill",
            IsDisabled = "IsDisabled",
            TaxRegType = "TaxRegType",
            GstVat = "GstVat",
            Pan = "Pan",
            CurrencyId = "CurrencyId",
            LbrFlag = "LbrFlag",
            StnFlag = "StnFlag",
            LbrFromDate = "LbrFromDate",
            LbrToDate = "LbrToDate",
            LbrPricegroupId = "LbrPricegroupId",
            LbrAddDisc = "LbrAddDisc",
            LbrAddMkp = "LbrAddMkp",
            StnFromDate = "StnFromDate",
            StnToDate = "StnToDate",
            CostPricegroupId = "CostPricegroupId",
            StnAddDisc = "StnAddDisc",
            StnAddMkp = "StnAddMkp",
            AddressDetails = "AddressDetails",
            ContactDetails = "ContactDetails",
            Token = "Token",
            APIEndpoint = "APIEndpoint",
            APIToken = "APIToken",
            AutoCreateVoucherUsingAPI = "AutoCreateVoucherUsingAPI",
            AutoPosting = "AutoPosting",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
